module.exports = __webpack_public_path__ + "0cb02ae6c6ec4ea5414fd82405b33cd2.png";